import {
  DynamicFormComponentRegistry,
  QuestionnaireComponentKind,
  QuestionnaireFormComponentRegistry,
} from '@main/dynamic-form';
import {
  EditableInputField,
  FileField,
  MarkdownField,
  OptionsField,
  ReadInputField,
  ReadOptionsField,
} from '@main/dynamic-form-fields';

import { SectionField } from './section';

let componentRegistry: QuestionnaireFormComponentRegistry | undefined;
let readComponentRegistry: QuestionnaireFormComponentRegistry | undefined;

/**
 * Lazily creates and returns the component registry for the questionnaire
 * form: the answering one, or the read view a reviewer reads a submission in.
 */
export function useQuestionnaireComponentRegistry({ isReadView = false } = {}) {
  if (isReadView) {
    readComponentRegistry ??= createReadComponentRegistry();
    return { componentRegistry: readComponentRegistry };
  }

  componentRegistry ??= createComponentRegistry();
  return { componentRegistry };
}

export function createComponentRegistry(): QuestionnaireFormComponentRegistry {
  return new DynamicFormComponentRegistry({
    [QuestionnaireComponentKind.Number]: EditableInputField,
    [QuestionnaireComponentKind.Date]: EditableInputField,
    [QuestionnaireComponentKind.Email]: EditableInputField,
    [QuestionnaireComponentKind.Url]: EditableInputField,
    [QuestionnaireComponentKind.Text]: MarkdownField,
    [QuestionnaireComponentKind.Options]: OptionsField,
    [QuestionnaireComponentKind.File]: FileField,
    [QuestionnaireComponentKind.Section]: SectionField,
  });
}

/** Every answer as text; markdown and files already read as text when read-only. */
function createReadComponentRegistry(): QuestionnaireFormComponentRegistry {
  return new DynamicFormComponentRegistry({
    [QuestionnaireComponentKind.Number]: ReadInputField,
    [QuestionnaireComponentKind.Date]: ReadInputField,
    [QuestionnaireComponentKind.Email]: ReadInputField,
    [QuestionnaireComponentKind.Url]: ReadInputField,
    [QuestionnaireComponentKind.Text]: MarkdownField,
    [QuestionnaireComponentKind.Options]: ReadOptionsField,
    [QuestionnaireComponentKind.File]: FileField,
    [QuestionnaireComponentKind.Section]: SectionField,
  });
}
